import INotification from "app/models/notification"
import * as selectors from "app/redux/notifications/notifications.selectors"
import IState from "app/redux/state"
import React, { memo } from "react"
import { connect } from "react-redux"
import Notification from "./Notification"

type StateProps = {
  notifications: INotification[]
}

function Notifications({ notifications }: StateProps): any {
  return notifications.map((notification: INotification) => (
    <Notification
      id={notification.id}
      key={notification.id}
      message={notification.message}
      values={notification.values}
      state={notification.variant}
    />
  ))
}

const mapStateToProps = (state: IState): StateProps => ({
  notifications: selectors.getNotifications(state),
})

export default connect(mapStateToProps)(memo(Notifications))
